export { default } from "./PlayerInView";
